var ImmersiveReaderFrameState;
(function (ImmersiveReaderFrameState) {
    ImmersiveReaderFrameState[ImmersiveReaderFrameState["Closed"] = 0] = "Closed";
    ImmersiveReaderFrameState[ImmersiveReaderFrameState["Showing"] = 1] = "Showing";
    ImmersiveReaderFrameState[ImmersiveReaderFrameState["Ready"] = 2] = "Ready";
})(ImmersiveReaderFrameState || (ImmersiveReaderFrameState = {}));
export default ImmersiveReaderFrameState;
//# sourceMappingURL=ImmersiveReaderFrameState.js.map